import React, { useEffect, useRef, useState } from 'react';
import { parse, SvgAst } from 'react-native-svg';

// SvgUri reports fetch failures, but its internal SvgXml does not forward
// parse failures. Parse before publishing a loaded image so corrupt SVGs can
// use the same thumbnail/Retry path as a failed request.
export default function NativeSvgPreview({ uri, onLoad, onError, ...override }) {
  const [ast, setAst] = useState(null);
  const callbacks = useRef(null);
  callbacks.current = { onLoad, onError };
  useEffect(() => {
    let active = true;
    const controller = new AbortController();
    setAst(null);
    (async () => {
      try {
        const response = await fetch(uri, { signal: controller.signal });
        if (!response.ok && !(response.status === 0 && uri.startsWith('file://'))) throw new Error('Could not load SVG');
        const xml = await response.text();
        if (!active) return;
        const next = parse(xml);
        if (!next || next.tag !== 'svg') throw new Error('Not an SVG image');
        setAst(next);
        callbacks.current.onLoad?.();
      } catch (error) {
        if (active) callbacks.current.onError?.(error);
      }
    })();
    return () => { active = false; controller.abort(); };
  }, [uri]);
  return <SvgAst ast={ast} override={override} />;
}
